import { ComponentErrors } from "@/types/ComponentErrors";
import { Alert, AlertDescription, AlertTitle } from "@components/ui/alert";
import { Trans } from "@lingui/react/macro";
import { AlertCircleIcon } from "lucide-react";

type QueryBuilderErrorsProps = {
  errors: ComponentErrors;
};

export default function QueryBuilderErrors({
  errors,
}: QueryBuilderErrorsProps) {
  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>
        <Trans>Fel i bevakningen</Trans>
      </AlertTitle>
      <AlertDescription>
        <p>
          <Trans>Följande fel uppstod när du försökte spara bevakningen:</Trans>
        </p>
        <ul className="list-inside list-disc text-sm">
          {errors.title && <li>{errors.title}</li>}

          {errors.start_date && <li>{errors.start_date}</li>}

          {errors.end_date && <li>{errors.end_date}</li>}

          {errors.search_type && <li>{errors.search_type}</li>}

          {errors.sorting_position && <li>{errors.sorting_position}</li>}

          {errors.queries?.map((e, queryIndex) =>
            Object.keys(e).map((subError) =>
              Array.isArray(e[subError]) ? (
                (e[subError] as string[]).map((fieldError, index) => (
                  <li key={`${subError}-${queryIndex}-${index}`}>
                    {fieldError}
                  </li>
                ))
              ) : (
                <li key={`${subError}-${queryIndex}`}>{e[subError]}</li>
              )
            )
          )}

          {errors.non_field_errors?.map((e, index) => {
            return <li key={`non-field-query-error-${index}`}>{e}</li>;
          })}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
